import { render } from "./PaletteDeterminantView.vue?vue&type=template&id=de349896&scoped=true&ts=true"
import script from "./PaletteDeterminantView.vue?vue&type=script&lang=ts"
export * from "./PaletteDeterminantView.vue?vue&type=script&lang=ts"

import "./PaletteDeterminantView.vue?vue&type=style&index=0&id=de349896&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de349896"]])

export default __exports__